<template>
  <div class="container">
    <!-- 头部 -->
    <div class="header">
      <div class="in_wrap">
        <img src="@/assets/img/logo.png" />
        <!-- <h2>South南方测绘旗舰店欢迎你!</h2> -->
      </div>
    </div>
    <!-- 主体内容 -->
    <div class="main">
      <!-- 轮播图 -->
      <el-carousel :interval="4000" height="600px">
        <el-carousel-item v-for="item in imageList" :key="item">
          <img style="width: 100%; height: 100%" :src="item.url" />
        </el-carousel-item>
      </el-carousel>
      <!-- 旗舰店模块 -->
      <div class="card-box">
        <div class="title">
          <h3>应用推荐</h3>
        </div>
        <el-row :gutter="40">
          <el-col :span="8">
            <el-card class="card-item" shadow="always" @click="goToTmall()">
              <img
                style="width: 90px; height: 90px"
                src="@/assets/img/right-tmall.png"
              />
              <p>欢迎光临</p>
              <p>南方测绘天猫官方旗舰店</p>
              <el-button style="margin-top: 20px" color="#d1000f" round
                >立即进入</el-button
              >
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card class="card-item" shadow="always" @click="goToJd()">
              <img
                style="width: 90px; height: 90px"
                src="@/assets/img/right-jd.png"
              />
              <p>欢迎光临</p>
              <p>南方测绘京东官方旗舰店</p>
              <el-button style="margin-top: 20px" color="#d1000f" round
                >立即进入</el-button
              >
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card
              class="card-item"
              shadow="always"
              @click="goToSouthCloud()"
            >
              <img
                style="
                  width: 90px;
                  height: 90px;
                  background: #e50012;
                  object-fit: none;
                  border-radius: 5px;
                "
                src="@/assets/img/cloud.png"
              />
              <p>欢迎使用</p>
              <p>南方测绘统一认证平台</p>
              <el-button style="margin-top: 20px" color="#d1000f" round
                >立即进入</el-button
              >
            </el-card>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 底部 -->
    <div class="footer">
      <div class="top">
        <div class="wrap about">
          <div class="left">
            <div class="x_ion">
              <img src="@/assets/img/logo_foot.png" />
            </div>
            <p class="text">
              <img
                style="width: 12px; height: 12px"
                src="@/assets/img/position.png"
              />
              广州市天河智慧城思成路39号南方测绘地理信息产业园6楼
            </p>
            <p class="text">
              <img
                style="width: 12px; height: 12px"
                src="@/assets/img/telephone.png"
              />
              020-2338-0888
            </p>
            <p class="text">全国统一热线</p>
            <p class="text tel">400 7000 700</p>
          </div>
          <div class="center">
            <div>
              <div class="x_ion">关于我们</div>
              <ul>
                <li>
                  <a href="http://www.southgnss.com/news.html">新闻资讯</a>
                </li>
                <li>
                  <a href="http://www.southgnss.com/about/id/1.html"
                    >公司简介</a
                  >
                </li>
                <li>
                  <a href="http://www.southgnss.com/about/id/2.html"
                    >企业文化</a
                  >
                </li>
                <li>
                  <a href="http://www.southgnss.com/about/id/5.html">大事记</a>
                </li>
                <li>
                  <a href="http://www.southgnss.com/about/id/4.html"
                    >资质荣誉</a
                  >
                </li>
                <li>
                  <a href="http://www.southgnss.com/about/id/6.html"
                    >联系我们</a
                  >
                </li>
              </ul>
            </div>
            <div>
              <div class="x_ion">服务与支持</div>
              <ul>
                <li>
                  <a href="http://www.southgnss.com/download.html">下载中心</a>
                </li>
                <li>
                  <a href="http://www.southgnss.com/question.html">常见问题</a>
                </li>
                <li>
                  <a href="http://www.southgnss.com/network.html">服务网络</a>
                </li>
                <li>
                  <a href="http://www.southgnss.com/otherinfo/cid/1.html"
                    >安全公告</a
                  >
                </li>
              </ul>
            </div>
            <div>
              <div class="x_ion">快速链接</div>
              <ul>
                <li>
                  <a href="http://sso.southgnss.com/web/login/main.html"
                    >统一认证中心</a
                  >
                </li>
                <li>
                  <a href="http://oa.southgnss.com/GNSSLogin.aspx">OA系统</a>
                </li>
                <li>
                  <a href="http://zcm.southgnss.com/admin/login.aspx"
                    >注册码系统</a
                  >
                </li>
                <li>
                  <a href="http://old.southgnss.com/">旧版本官网</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="right">
            <div class="x_ion">关注</div>
            <div class="follow">
              <div>
                <img src="@/assets/img/2weixin.png" />
                <p>关注公众号</p>
              </div>
              <div>
                <img src="@/assets/img/2weibo.png" />
                <p>关注微博</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="wrap cf">
          Copyright © 2022 广州南方卫星导航仪器有限公司 All Rights Reserved
          粤ICP备14099643号-1
        </div>
      </div>
    </div>

    <el-backtop :bottom="100">
      <div
        style="
          height: 100%;
          width: 100%;
          background-color: var(--el-bg-color-overlay);
          box-shadow: var(--el-box-shadow-lighter);
          text-align: center;
          line-height: 40px;
          color: #d1000f;
        "
      >
        UP
      </div>
    </el-backtop>
  </div>
</template>

<script>
import { reactive } from "vue";
export default {
  name: "App",
  setup() {
    let imageList = reactive([
      { url: require("@/assets/img/banner1.jpg") },
      { url: require("@/assets/img/banner2.jpg") },
      { url: require("@/assets/img/banner3.jpg") },
      { url: require("@/assets/img/banner4.jpg") },
      { url: require("@/assets/img/banner5.jpg") },
      { url: require("@/assets/img/banner6.jpg") },
      { url: require("@/assets/img/banner7.jpg") },
      { url: require("@/assets/img/banner8.jpg") },
    ]);

    const goToTmall = () => {
      window.open(
        "https://south.tmall.com/?spm=a1z10.1-b-s.1997427721.d4918089.1f247986MI5dSL",
        "_blank"
      );
    };

    const goToJd = () => {
      window.open("https://mall.jd.com/index-1000429274.html", "_blank");
    };

    const goToSouthCloud = () => {
      window.open("http://cloud.southgnss.com:15020/#/login", "_blank");
    };

    return {
      imageList,
      goToTmall,
      goToJd,
      goToSouthCloud,
    };
  },
};
</script>

<style>
body {
  margin: 0;
  padding: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.header {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 90px;
  z-index: 1000000;
  background: #fff;
  box-shadow: 0 0 4px #ccc;
}

.in_wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 1280px;
  height: 90px;
  margin: 0 auto;
}

.in_wrap h2 {
  font-size: 20px;
  color: #d1000f;
  font-style: italic;
}

.main {
  margin-top: 90px;
}

.card-box {
  width: 1280px;
  margin: 0 auto;
  padding-bottom: 50px;
}

.title h3 {
  font-size: 40px;
  font-weight: 300;
  color: #333;
}

.card-item {
  /* width: 100%; */
  padding: 50px 0;
  border-radius: 10px;
  cursor: pointer;
}

.card-item p {
  color: #d1000f;
}

.footer {
  background-color: #303036;
  color: #999;
}

.wrap {
  width: 1280px;
  margin: 0 auto;
}

.about {
  position: relative;
  display: flex;
  justify-content: space-between;
  min-height: 240px;
  padding: 20px 0;
  text-align: left;
}

.about .text {
  font-size: 14px;
}

.about .tel {
  font-size: 30px;
  color: #fff;
  padding: 0 0;
  line-height: 30px;
}

.wrap .center {
  flex: 1;
  display: flex;
  justify-content: space-between;
  margin-left: 110px;
}

.wrap .right {
  width: 220px;
  margin-left: 100px;
}

.wrap .x_ion {
  position: relative;
  margin-bottom: 15px;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  line-height: 50px;
}

.wrap .x_ion::before {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  display: inline-block;
  width: 30px;
  height: 2px;
  background: #d1000f;
  border-radius: 2px;
}

.wrap ul {
  padding: 0;
}

.wrap ul li {
  list-style: none;
  line-height: 16px;
  padding-bottom: 20px;
  font-size: 14px;
}

.wrap li a {
  text-decoration: none;
  color: #999;
}

.wrap .follow {
  display: flex;
  justify-content: space-between;
}

.wrap .follow p {
  text-align: center;
  font-size: 14px;
}

.wrap li a:hover {
  color: #fff;
}

.footer .top {
  padding: 60px 0 40px 0;
}

.footer .bottom {
  font-size: 13px;
  line-height: 14px;
  padding: 15px 0;
  border-top: 1px solid #3b3b40;
}
</style>
